import React from "react";
import CustomIcon from "components/CustomIcon";
import Image from "next/image";

export const EmploymentOverlapWarning: React.FC = () => {
  return (
    <div className="relative flex flex-col mx-1 gap-[10px] rounded-xl bg-[#CEFAFF94] px-[15px] py-[10px] lg:gap-[16px] lg:px-[20px] lg:py-[14px]">
      <div className="absolute left-4 top-[-16px] flex items-center gap-2 rounded-xl bg-white px-4 py-2 font-bold text-black shadow-md lg:left-8 lg:px-6">
        <Image
          src="/icons/score-check/Announcement.svg"
          height={24}
          width={24}
          alt="icon"
          className="h-4 w-4 lg:h-5 lg:w-5"
        />
        <span className="text-sm font-bold lg:text-base xl:text-lg">
          Employment Overlap Detected
        </span>
      </div>
      <ul className="flex list-disc flex-col items-center px-[3px] marker:text-base marker:text-[#92C5FF] sm:px-[5px] sm:marker:text-lg lg:marker:text-2xl">
        <div className="relative mx-auto h-32 w-32 lg:h-40 lg:w-40">
          <Image
            src="/assets/resumeScore/Gap.png"
            alt="Employment Overlap illustration"
            fill
            className="object-contain"
          />
        </div>

        <li className="my-[6px] flex items-center  gap-2 text-xs font-medium text-[#B94444] md:text-base lg:gap-4 lg:text-base xl:my-[6px] xl:text-lg">
          {/* <div className="h-auto w-auto"><CustomIcon iconName="cross" className="w-3 h-3 lg:w-4 lg:h-4" /></div> */}
          There is more than 2 months overlap between experiences
        </li>
      </ul>
    </div>
  );
};
